import { WebformFragment } from "@/__generated__/graphql";
import { GridContainer, GridWrapper } from "@theme/lib";
import IFrameResizer from "iframe-resizer-react";
import { ReactElement, useEffect, useState } from 'react';
import styled from "styled-components";

const WebformWrapper = styled(GridWrapper)`
`;

export default function Webform({ url, __typename, id }: WebformFragment): ReactElement<any> {
  const [formUrl, setFromUrl] = useState(url);

  // Add search params starting with wf__ to the Iframe as params.
  useEffect(()=>{
    if(window && window.location.search) {
      const query = new URLSearchParams(window.location.search);
      let iframeParams: string[] = [];
      query.forEach((value, key) => {
        if(key.startsWith('wf__')) {
          iframeParams.push(`${key.replace('wf__', '')}=${value}`)
        }
      });

      if (iframeParams.length) {
        setFromUrl(`${url}?${iframeParams.join('&')}`)
      }
    }
  }, [url]);

  return formUrl ? (
    <GridContainer className={__typename} key={id}>
      <WebformWrapper alignment="full-width">
        <IFrameResizer src={formUrl} style={{ width: '1px', minWidth: '100%' }} />
      </WebformWrapper>
    </GridContainer>
  ) : <></>;
}
